import { render, staticRenderFns } from "./RightToOccupy1.vue?vue&type=template&id=6d76ce0b"
import script from "./RightToOccupy1.vue?vue&type=script&lang=js"
export * from "./RightToOccupy1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports